import { Button, useNotify, useRefresh } from "react-admin";
import ModalComponent from "../../../../components/ModalComponent";
import IconCancel from "@material-ui/icons/Cancel";
import ActionDelete from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import { colors } from "material-ui/styles";
import {useListContext} from 'react-admin';

const DeleteOrdersConfirmationModal = ({ open, onClose, orderIds = [] }) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const { onUnselectItems } = useListContext();
    const total = Array.isArray(orderIds) ? orderIds.length : 0;

    const handleDeleteOrders = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL || '';
            const response = await fetch(`${apiUrl}/orders/delete`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    orderIds: orderIds
                })
            });
            if (!response.ok) throw new Error('Erro ao excluir pedidos');
            notify(`${total === 1 ? 'Pedido excluído' : 'Pedidos excluídos'} com sucesso`, { type: "success" });
        } catch (error) {
            notify("Falha ao excluir " + (total === 1 ? "pedido" : "pedidos"), { type: "error" });
        }
        onUnselectItems();
        onClose();
        refresh();
    }

    const handleCancel = () => {
        onUnselectItems();
        onClose();
        refresh();
    };

    return (
        <ModalComponent
            open={open}
            onClose={handleCancel}
            title={total > 1 ? "Confirmar exclusão dos pedidos" : "Confirmar exclusão do pedido"}
            content={
                total === 1 ?
                <p>Deseja excluir o pedido <strong>{orderIds[0]}</strong>? Ao confirmar, não será possível reverter essa operação.</p>
                : <p>Deseja excluir os <strong>{total}</strong> pedidos selecionados? Ao confirmar, não será possível reverter essa operação.</p>
            }
            actions={
                <>
                    <Button onClick={handleCancel} label="Cancelar">
                        <IconCancel />
                    </Button>
                    <Button disabled={!total} style={{ color: colors.red500 }} onClick={handleDeleteOrders} label="Deletar">
                        <ActionDelete />
                    </Button>
                </>
            }
        />
    );
};

DeleteOrdersConfirmationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func,
    orderIds: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
};

export default DeleteOrdersConfirmationModal;